export default __webpack_public_path__ + "static/media/gallery-wip-connection-rods_01.24f96c61.jpg";